import { ConfigProperties } from 'src/app/shared/models/config';

export class ConfigBDP implements ConfigProperties {
    constructor(
        public enableAccesories = false,
        public allowAWBSubscription = false,
        public maxItemsPerCart = 1,
        public allowPaymentsWithoutISCPaid = true,
        public minimumAmountAllowed = 1,
        public enableChargeEdition = false,
        public labelAWB = 'Air waybill',
        public showBreadcrumbs = true
    ) {}
}
